<template minapp="mpx" xlang="wxml">
  <view class="recommend" wx:style="{{beforeDirective}}">
    <view class="left">
      {{ recommendTicket.tips }}
      <view class="gap"></view>
      {{ recommendTicket.plan }}
      <text class="price">{{ recommendTicket.price }}</text>
      <text class="station">{{ recommendTicket.diffStationNum }}</text>
    </view>
    <view class="right" bindtap="click">详情</view>
  </view>
  <recommend-ticket-drawer
    show="{{showDrawer}}"
    bind:close="closeDrawer"
    trainInfo="{{trainInfo}}"
    recommendTicketDrawer="{{recommendTicketDrawer}}"
  />
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {
      recommendTicket: {
        // 列表页推荐条数据
        type: Object,
        value: {}
      },
      recommendTicketDrawer: {
        // 列表页推荐弹窗数据
        type: Object,
        value: {}
      },
      trainInfo: {
        // 原车次信息
        type: Object,
        value: {}
      }
    },
    data: {
      showDrawer: false
    },
    mounted() {

    },
    computed: {
      //before指向
      beforeDirective(){
        const style = {}
        style['--left'] = this.trainInfo.recommend_ticket[0].seat_type  == 'M'? '40%' : '10%'
        return style
      }
    },
    methods: {
      ...store.mapMutations({
        setRecommendCardInfo: 'train.setRecommendCardInfo',
      }),
      click() {
        // 打开弹窗
        this.setRecommendCardInfo(this.recommendTicketDrawer)
        this.showDrawer = true
      },
      closeDrawer() {
        this.showDrawer = false
      }
    }
  })
</script>

<style scoped lang="stylus">
  @import '~@/mixins/stylus/color.styl'
  :root
    --left:30px
  .recommend
    height 32px
    background #EEF5FF
    margin 10px -15px -13px -15px
    border-radius 0 0 16px 16px
    display flex
    justify-content space-between
    font-size 11px
    color #333333
    align-items center
    padding 0 26px 0 16px
    position relative
    &::before
      content ''
      position absolute
      border-left 8px solid transparent
      border-right 8px solid transparent
      border-bottom 8px solid #EEF5FF
      left var(--left)
      top -6px
  .left
    display flex
    align-items center
  .right
    position relative
    &::after
      content ''
      position absolute
      border-top 1px solid
      border-right 1px solid
      width 4px
      height 4px
      transform rotate(45deg)
      top 5px
  .gap
    background #CCCCCC
    width 1px
    height 10px
    margin 0.5px 8px
  .price
    color #FF6400
    font-weight 800
  .station
    color #338FFF
</style>

<script name="json">
  module.exports = {
    component: true,
    usingComponents: {
      'recommend-ticket-drawer': './drawer'
    }
  }
</script>